import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';

export const WIZARD_FIELDS = [
	'wizardStep',
	'previousSteps',
	'selectedProjectId',
	'selectedFeatureTypeId',
	'selectedAppId',
	'selectedInstallableId',
	'selectedPlacementId',
	'selectedPlacementVersionId',
	'selectedContextId',
	'selectedCredentialsConfiguration',
	'selectedServiceWorkspaceId',
	'selectedPlacementParamsMap',
	'selectedPlacementParamsMapLabels',
	'selectedToolPlacementId',
	'selectedElementType',
	'selectedTabIndex',
	'disabledTabs',
];

export const FIELDS_METADATA = {
	previousSteps: { default: () => [] },
	selectedProjectId: { default: () => null, deps: [] },
	selectedFeatureTypeId: { default: () => null, deps: ['selectedAppId', 'selectedToolPlacementId'] },
	selectedAppId: { default: () => null, deps: ['selectedInstallableId', 'selectedPlacementId', 'selectedCredentialsConfiguration'] },
	selectedInstallableId: { default: () => null, deps: ['selectedPlacementParamsMap', 'selectedPlacementParamsMapLabels'] },
	selectedPlacementId: {
		default: () => null,
		deps: [
			'selectedInstallableId',
			'selectedPlacementParamsMap',
			'selectedPlacementParamsMapLabels',
			'selectedElementType',
			'selectedContextId',
			'selectedPlacementVersionId',
		],
	},
	selectedPlacementVersionId: { default: () => null, deps: [] },
	// context id derived from the placement, for now we're not supporting multiple placements per context
	selectedContextId: { default: () => null, deps: [] },
	selectedCredentialsConfiguration: {
		default: () => ({ type: CredentialsTypes.Embedded, id: null }),
		deps: ['selectedPlacementId', 'selectedPlacementParamsMap', 'selectedPlacementParamsMapLabels'],
	},
	selectedPlacementParamsMap: { default: () => ({}) },
	selectedPlacementParamsMapLabels: { default: () => ({}) },
	selectedToolPlacementId: { default: () => null, deps: [] },
	selectedElementType: { default: () => null, deps: [] },
	selectedTabIndex: { default: () => 0, deps: [] },
	disabledTabs: { default: () => [], deps: [] },
};
